import { HocuspocusProviderWebsocket } from '@hocuspocus/provider';
import React, {
  ReactNode,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Y_SERVER } from 'src/config-global';
import { Color } from 'src/generated/graphql';
import { randomBetween } from 'src/utils/utils';

type SocketContextType = {
  socket: HocuspocusProviderWebsocket;
  awarenessColor: string;
};

const SocketContext = React.createContext<SocketContextType | null>(null);

const factory = () =>
  new HocuspocusProviderWebsocket({
    url: Y_SERVER,
  });

export function useCollaborationContext(): SocketContextType {
  const ctx = useContext(SocketContext);

  if (!ctx) {
    throw new Error(
      "can't use useCollaborationContext outside of an CollaborationSocketProvider",
    );
  }
  return ctx;
}

const AVAILABLE_COLORS = Object.values(Color);

export function CollaborationContextProvider({
  children,
}: { children: ReactNode }): JSX.Element {
  const client = useMemo(() => factory(), []);

  const [awarenessColor] = useState(
    AVAILABLE_COLORS[randomBetween(0, AVAILABLE_COLORS.length - 1)],
  );

  useEffect(() => {
    client.on('disconnect', () => {
      client.connect();
    });

    client.connect();

    return () => {
      client.destroy();
    };
  }, [client]);

  return (
    <SocketContext.Provider
      value={{
        socket: client,
        awarenessColor,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
}
